import { defineMessages } from "react-intl";

export const columnsMessages = defineMessages({
  customer: {
    id: "3+a9bR",
    defaultMessage: "Customer",
    description: "cart visibility list column",
  },
  items: {
    id: "BsNU7o",
    defaultMessage: "Items",
    description: "cart visibility list column",
  },
  total: {
    id: "tPy/dp",
    defaultMessage: "Total",
    description: "cart visibility list column",
  },
  lastChange: {
    id: "0t3HAi",
    defaultMessage: "Last change",
    description: "cart visibility list column",
  },
  status: {
    id: "hTezkm",
    defaultMessage: "Status",
    description: "cart visibility list column",
  },
});

export const messages = defineMessages({
  emptyText: {
    id: "BRoYh7",
    defaultMessage: "No live carts yet",
    description: "cart visibility list empty state",
  },
  anonymous: {
    id: "qoOKEt",
    defaultMessage: "Anonymous",
    description: "cart with no customer email",
  },
  notPromoted: {
    id: "vCx7NK",
    defaultMessage: "Not promoted",
    description: "cart has no linked draft order yet",
  },
  takeOver: {
    id: "fpdMz4",
    defaultMessage: "Take over",
    description: "promote cart to draft order row action",
  },
  openDraft: {
    id: "Gon9QD",
    defaultMessage: "Open draft #{number}",
    description: "open the linked draft order row action",
  },
});
